(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
// Shopify valideert de contactform aan de serverkant: een fout komt terug na een
// herlaadbeurt, bovenaan de pagina. Zonder deze regels merkt iemand die met een
// schermlezer of alleen met het toetsenbord werkt daar niets van — de focus staat
// dan weer op <body> en de melding staat buiten beeld. Daarom: focus naar de
// samenvatting (die de eerste fout als eerste link bevat), of naar de bevestiging.
(function () {
  var doel = document.querySelector('[data-contact-focus]');
  if (!doel) return;
  doel.focus();
  doel.scrollIntoView({ block: 'center', behavior: 'smooth' });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-orbit"] && !Shopify.designMode) return;
  try {
    
/*
  product-orbit — één taak: welk kenmerk is "aan".

  Wat dit script NIET doet, en dat is het belangrijkste eraan:
  - het scrolt niets, springt nergens heen en zet geen scrollpositie vast;
    de bezoeker houdt zijn eigen snelheid (geen scroll-hijacking);
  - het leest geen enkele afmeting op, dus er is geen lus die per frame layout
    leest en schrijft;
  - het toont en verbergt niets. Alle inhoud staat al in de HTML. Zonder dit
    script staan alle kenmerken er gewoon, in dezelfde rustige staat.

  Hoe: één IntersectionObserver met een root-marge die de viewport tot een lijn
  op halve hoogte terugbrengt. De ankers (desktop) of de kenmerken zelf
  (mobiel) liggen aaneengesloten, dus er kruist er altijd precies één die lijn.
  Een observer vuurt alleen bij een grensovergang.
*/
(() => {
  const KLASSE = 'is-aan';
  const rustig = window.matchMedia('(prefers-reduced-motion: reduce)');
  const breed = window.matchMedia('(min-width: 1024px)');
  const gedaan = new WeakMap();

  function start(orbit) {
    const kenmerken = [...orbit.querySelectorAll('.orbit__kenmerk')];
    if (!kenmerken.length) return;

    let observer = null;

    const zetAan = (index) => {
      kenmerken.forEach((el, i) => el.classList.toggle(KLASSE, i === index));
    };

    const stop = () => {
      if (observer) { observer.disconnect(); observer = null; }
      kenmerken.forEach((el) => el.classList.remove(KLASSE));
    };

    const opnieuw = () => {
      stop();
      /* Bij reduced motion is er geen volgorde om te markeren: alles staat
         onder elkaar en alles is even belangrijk. */
      if (rustig.matches) return;

      /* Op desktop tellen de ankers in het spoor, daaronder de kenmerken zelf.
         Het spoor staat onder 1024 px op display:none en heeft dan geen box. */
      const ankers = [...orbit.querySelectorAll('.orbit__anker')];
      const doelen = breed.matches && ankers.length === kenmerken.length ? ankers : kenmerken;

      observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const i = Number(entry.target.dataset.orbitIndex);
          if (Number.isInteger(i)) zetAan(i);
        }
      }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });

      doelen.forEach((el) => observer.observe(el));
    };

    opnieuw();
    rustig.addEventListener('change', opnieuw);
    breed.addEventListener('change', opnieuw);
  }

  function alles(wortel) {
    (wortel || document).querySelectorAll('.orbit').forEach((orbit) => {
      if (gedaan.has(orbit)) return;
      gedaan.set(orbit, true);
      start(orbit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => alles());
  } else {
    alles();
  }

  /* De theme-editor bouwt een sectie opnieuw op zonder de pagina te herladen. */
  document.addEventListener('shopify:section:load', (e) => alles(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
